import { createContext, useContext, useState } from 'react';

interface DiscoverContextType {
  /** true = V1 swipe overlay is active; bottom dock is hidden app-wide */
  swipeModeActive: boolean;
  setSwipeModeActive: (active: boolean) => void;
}

const DiscoverContext = createContext<DiscoverContextType>({
  swipeModeActive: false,
  setSwipeModeActive: () => {},
});

export function DiscoverProvider({ children }: { children: React.ReactNode }) {
  const [swipeModeActive, setSwipeModeActive] = useState(false);
  return (
    <DiscoverContext.Provider value={{ swipeModeActive, setSwipeModeActive }}>
      {children}
    </DiscoverContext.Provider>
  );
}

export function useDiscoverContext() {
  return useContext(DiscoverContext);
}
